import React from "react";
import { useCallback } from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const Particle = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);
  return (
    <div className="relative !mx-0">
      <div
        className="text-white xl:w-5/6 md:w-8/12 w-full"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          paddingBottom: "30px",
          transform: "translate(-50%,-50%)",
        }}
      >
        <div className="flex items-center justify-center xl:justify-start mt-8 xl:mt-0">
          <div className="border-t-2 w-1/5 mr-4 border-primary"></div>
          <div>
            <p className="text-lg">About Me</p>
          </div>
        </div>
        <h1 className="xl:text-6xl text-4xl font-black xl:text-left">
          I'm a Front End web developer working from home
        </h1>

        <div className="border-t-2 w-1/5 mx-auto xl:mr-4 xl:mx-0 mt-8 border-primary"></div>
        <p className="xl:text-left xl:mt-8 mt-4 text-base">
          My expertise in React allows me to create smooth, responsive user
          interfaces that deliver an exceptional user experience.{" "}
          <span className="hidden xl:inline">
            I'm comfortable working with a variety of other front-end and
            back-end technologies, and I'm always learning and exploring new
            tools and frameworks to stay up-to-date with the latest trends.
          </span>
        </p>
        <div className="text-2xl mt-4 mb-24 flex items-center justify-center xl:justify-start gap-4">
          <div className="cursor-pointer">
            <a
              href="https://www.facebook.com/Rahat108/"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>
          <div className="cursor-pointer">
            <a
              href="https://twitter.com/Rahatsikder_"
              target="_blank"
              rel="noreferrer"
            >
              <FaTwitter />
            </a>
          </div>
          <div className="cursor-pointer">
            <a
              href="https://www.instagram.com/rahat_sikder/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
      <Particles
        className="lg:h-[100vh] h-[50vh]"
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "#0F172A",
            },
          },
          fullScreen: {
            enable: false,
            zIndex: -1,
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              directions: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 2800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  );
};

export default Particle;
